import type { StripePaymentMethodMessagingElementOptions } from '@stripe/stripe-js';

export type MessagingCurrency =
  StripePaymentMethodMessagingElementOptions['currency'];

export type MessagingCountry = NonNullable<
  StripePaymentMethodMessagingElementOptions['countryCode']
>;

/**
 * Stripe never resolves the message when it cannot bind it to a supported buyer
 * country, and the element reports no error of its own — it simply never fires
 * `ready`, so the row would sit blank forever. Gate on the country instead.
 */
export const MESSAGING_COUNTRIES: Record<MessagingCountry, true> = {
  AT: true,
  AU: true,
  BE: true,
  CA: true,
  CH: true,
  CZ: true,
  DE: true,
  DK: true,
  ES: true,
  FI: true,
  FR: true,
  GB: true,
  GR: true,
  IE: true,
  IT: true,
  NL: true,
  NO: true,
  NZ: true,
  PL: true,
  PT: true,
  RO: true,
  SE: true,
  US: true,
};

/**
 * Shop addresses store a country either as an ISO-2 code or as a display name,
 * depending on how the shop was onboarded ('US' and 'United States' both occur).
 */
export const COUNTRY_NAMES_TO_CODES: Record<string, MessagingCountry> = {
  AUSTRALIA: 'AU',
  CANADA: 'CA',
  'GREAT BRITAIN': 'GB',
  'NEW ZEALAND': 'NZ',
  'UNITED KINGDOM': 'GB',
  'UNITED STATES': 'US',
  'UNITED STATES OF AMERICA': 'US',
  USA: 'US',
};

/** How long Stripe gets to render the message before we treat silence as a failure. */
export const READY_TIMEOUT_MS = 10_000;

export const MESSAGING_CURRENCIES: Record<MessagingCurrency, true> = {
  AUD: true,
  CAD: true,
  CHF: true,
  CZK: true,
  DKK: true,
  EUR: true,
  GBP: true,
  NOK: true,
  NZD: true,
  PLN: true,
  SEK: true,
  USD: true,
};
